import React, { useState } from "react";
import { Button, Card, CardHeader, CardBody, Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { loadStripe } from "@stripe/stripe-js";
import _fetch from "../../_fetch";
import { toast } from "react-toastify";
import { Elements } from "@stripe/react-stripe-js";
import Loader from "../../components/Loader/loader";
import AddressForm from "../Subscription/AddressForm";
import CheckoutFormCart from "./CheckoutFormCart";


const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function Payment({ order }) {
    console.log("Payment order:", order);
    const [elementType, setElementType] = useState(0);
    const { stripeAddress, isFreeTrialAvailable } = useSelector(
        (state) => state.user
    );


    const [clientSecret, setClientSecret] = useState("");
    const [amount, setAmount] = useState({});
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const { first_name, last_name, email } = useSelector(st => st.user);
    console.log("Stripe Address:", stripeAddress, first_name, last_name, email);
    const [, , removeCookie] = useCookies(['cart', 'live_class_count']);

    const product_details = {
        "LIVE": {
            "promo_code_message": "This promo code is applicable only on Live Classes"
        },
        "RECORDED": {
            "promo_code_message": "This promo code is applicable only on Workout Videos"
        },
        "60_MINS": {
            "promo_code_message": "This promo code is applicable only on 60 minute nutrition support consultation call",
            "name": "60 Minutes Nutrition Consultation Call",
            "price": process.env.REACT_APP_60_MIN_CALL_PRICE
        },
        "6_WEEKS": {
            "promo_code_message": "This promo code is applicable only on 6 week nutrition support plan",
            "name": "6 Weeks Nutrition Support Plan",
            "price": process.env.REACT_APP_6_WEEK_DIET_PRICE
        },
        "12_WEEKS": {
            "promo_code_message": "This promo code is applicable only on 12 week nutrition support plan",
            "name": "12 Weeks Nutrition Support Plan",
            "price": process.env.REACT_APP_12_WEEK_DIET_PRICE
        },
        "30_MINS_PT": {
            "promo_code_message": "This promo code is applicable only on 30 minutes personal training",
            "name": "30 Minutes Personal Training",
            "price": process.env.REACT_APP_30_MIN_PT_PRICE * order.personal_training.count
        },
        "45_MINS_PT": {
            "promo_code_message": "This promo code is applicable only on 45 minutes personal training",
            "name": "45 Minutes Personal Training",
            "price": process.env.REACT_APP_45_MIN_PT_PRICE * order.personal_training.count
        },
    };

    const handleStripeCheckout = async () => {

        try {
            console.log("Initiating Stripe Checkout for order:", order);
            console.log("User details:", { first_name, last_name, email });
            let res = await _fetch(`${process.env.REACT_APP_API_V2}/stripe-payment/orders`, {
                    method: 'POST',
                    body: {
                        invoice_id: order.invoice_id,
                        invoice_total: order.invoice_total,
                        currency: "gbp",
                        type:"PURCHASE",
                        customer: {
                        name: `${first_name}${last_name ? ` ${last_name}` : ""}`,
                        email,
                        },
                    },
                });
            if (res.success) {
                setClientSecret(res.response.client_secret);
                setAmount(res.response.amount);
                setElementType(1);
                setModalVisible(true);
			} else {
				toast.error(res.response);
			}

            const session = await res.json();
            console.log("Stripe session:", session);

            if (session.id) {
                removeCookie('cart');
                removeCookie('live_class_count');
                removeCookie('workout_video_count');
                removeCookie('diet_package');
                removeCookie('pt_package');
                removeCookie('pt_count');
            } else {
                alert("Failed to initiate payment. Please try again.");
            }

        } catch (err) {
            console.error("Stripe Checkout error:", err);
            alert("Something went wrong while processing payment.");
        }
    };

    const createStripeUser = async (address) => {
        try {
            setLoading(true);
            if (!address) return toast.error('Please enter your address!');
            let url = `${process.env.REACT_APP_API_V2}/stripe-payment/customer`;
            console.log("Creating Stripe customer with address:", address);
            let res = await _fetch(url, {
                method: 'POST',
                body: {
                    address: address,
                },
            });
            console.log("Create Stripe Customer response:", res);
            if (res.success) {
                console.log("Stripe customer created:", res.response);
                await handleStripeCheckout();
            } else {
                toast.error(res.response);
            }
        } catch (err) {
            console.log(err);
            toast.error('Something went wrong!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className="bg-secondary shadow h-100">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">Order Summary</h3>
                    </Col>
                </Row>
            </CardHeader>

            <CardBody>
                <Row>
                    <Col xs={7} md={8} className='font-weight-600'>Product</Col>
                    <Col xs={5} md={4} className='font-weight-600'>Subtotal</Col>
                </Row>
                <hr className="my-4" />

                {order.live_classes.count ? (
                    <>
                        <Row>
                            <Col xs={7} md={8}>
                                Live Classes&nbsp;
                                <span className='font-weight-600'>
                                    <i className='ni ni-fat-remove text-lg align-text-bottom'></i>&nbsp;
                                    {order.live_classes.count}
                                </span>
                            </Col>
                            <Col xs={5} md={4} className='font-weight-600'>£{order.live_classes.count * order.live_classes.price_per_class}</Col>
                        </Row>
                        <hr className="my-4" />
                    </>
                ) : null}

                {order.recorded_classes.count ? (
                    <>
                        <Row>
                            <Col xs={7} md={8}>
                                Workout Videos&nbsp;
                                <span className='font-weight-600'>
                                    <i className='ni ni-fat-remove text-lg align-text-bottom'></i>&nbsp;
                                    {order.recorded_classes.count}
                                </span>
                            </Col>
                            <Col xs={5} md={4} className='font-weight-600'>£{order.recorded_classes.count * order.recorded_classes.price_per_class}</Col>
                        </Row>
                        <hr className="my-4" />
                    </>
                ) : null}

                {order.diet_package.plan ? (
                    <>
                        <Row>
                            <Col xs={7} md={8}>
                                {product_details[order.diet_package.plan].name}
                            </Col>
                            <Col xs={5} md={4} className='font-weight-600'>£{product_details[order.diet_package.plan].price}</Col>
                        </Row>
                        <hr className="my-4" />
                    </>
                ) : null}

                {order.personal_training.plan ? (
                    <>
                        <Row>
                            <Col xs={7} md={8}>
                                {product_details[order.personal_training.plan].name}&nbsp;
                                <span className='font-weight-600'>
                                    <i className='ni ni-fat-remove text-lg align-text-bottom'></i>&nbsp;
                                    {order.personal_training.count}
                                </span>
                            </Col>
                            <Col xs={5} md={4} className='font-weight-600'>£{product_details[order.personal_training.plan].price}</Col>
                        </Row>
                        <hr className="my-4" />
                    </>
                ) : null}

                {order.promo_code ? (
                    <>
                        <Row>
                            <Col xs={7} md={8} className='pr-4'>
                                <div>Promo Code: <span className='font-weight-600'>{order.promo_code.name}</span></div>
                                <div className='text-xs text-info'>
                                    {product_details[order.promo_code.class_type]?.promo_code_message}
                                </div>
                            </Col>
                            <Col xs={5} md={4} className='font-weight-600'>
                                {order.promo_code.discount}%
                            </Col>
                        </Row>
                        <hr className="my-4" />
                    </>
                ) : null}

                <Row>
                    <Col xs={7} md={8} className='font-weight-600'>Total</Col>
                    <Col xs={5} md={4} className='font-weight-600'>£{order.invoice_total / 100}</Col>
                </Row>
                <hr className="my-4" />
            </CardBody>

            <CardBody>
                <Row>
                    <Col xs={{ size: 8, offset: 2 }}>
                        <Button
                            color="primary"
                            className="w-100"
                            onClick={
                                () => {
                                    if(stripeAddress) {
                                        handleStripeCheckout();
                                    } else {
                                        setModalVisible(true);
                                        setElementType(0);
                                    }
                            }
                        }
                        >
                            Complete Payment
                        </Button>
                    </Col>
                </Row>
            </CardBody>
            {modalVisible && (
				<Modal
					isOpen={modalVisible}
					toggle={() => {
						setModalVisible(false);
						setElementType(0);
						setClientSecret('');
					}}
					style={{
						maxWidth: '450px',
					}}
				>
					<ModalHeader
						toggle={() => {
							setModalVisible(false);
							setElementType(0);
							setClientSecret('');
						}}
					>
						Subscribe
					</ModalHeader>
					<ModalBody>
						{loading ? (
							<div className='w-100 h-100 d-flex justify-content-center align-items-center'>
								<Loader />
							</div>
						) : (
							<div>
								{elementType === 0 && (
									<Elements stripe={stripe}>
										<AddressForm onSubmit={createStripeUser} />
									</Elements>
								)}
								{elementType === 1 && (
									<Elements
										stripe={stripe}
										options={{
											clientSecret: clientSecret,
										}}
									>
										<CheckoutFormCart amount={amount} />
									</Elements>
								)}
							</div>
						)}
					</ModalBody>
				</Modal>
			)}
        </Card>
    );
}
